import { lazy } from 'react';

export const ObjectPageLazy = lazy(() => import('./ObjectPage'));
